/* eslint-disable */
import axios from "axios";
import moment from "moment";
import store from "../../store/index";
import jwt_decode from "jwt-decode";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import ChangeSchedulestatus from "../ChangeScheduleStatusPopup/ChangeScheduleStatusPopUp.vue";
import ChangeactivityStatusPopup from "../ChangeactivityStatusPopup/ChangeactivityStatusPopup.vue"
import AssignEproPopup from "../AssignEproPopup/AssignEproPopup.vue";
import CreateVideoCallSchedulePopUp from "../../components/CreateVideoCallSchedulePopUp/CreateVideoCallSchedulePopUp.vue";
import AssignFormSdvModal from "../AssignFormSdvModal/AssignFormSdvModal.vue";
export default {
  components: {
    VPagination,
    ChangeSchedulestatus,
    AssignEproPopup,
    CreateVideoCallSchedulePopUp,
    ChangeactivityStatusPopup,
    AssignFormSdvModal
  },
  data() {
    return {
      activitystatusreload:{},
      currentactivitystatus: "",
      selectedActivityid: "",
      temptemplatelist: [],
      showChangeTemplateModal: false,
      FillForm: "FillForm",
      sProp: "",
      IsDesc: true,
      defaultdate: "",
      roleprivileges: "",
      baseapi: process.env.VUE_APP_Service_URL,
      localurl: process.env.VUE_APP_redirect,
      baseUrl: `${process.env.VUE_APP_Service_URL}/management/patientschedule/`,
      currentTemplatePage: 1,
      totalTemplatePages: 1,
      overduevisits: [],
      plannedvisits: [],
      sites: [],
      pageplannedindex: 1,
      pageplannedsize: 10,
      recentpageplannedsize: 10,
      currentplannedPage: 1,
      totalplannedCount: 0,
      totalrecentCount: 0,
      totalplannedPages: 0,
      pageoverdueindex: 1,
      pageoverduesize: 10,
      currentoverduePage: 1,
      totaloverdueCount: 0,
      totaloverduePages: 0,
      pageformindex: 1,
      pageformsize: 10,
      currentformPage: 1,
      totalformCount: 0,
      totalformPages: 0,
      patientLists: [],
      visitobj: {},
      hasadditionalforms:{},
      formList: [],
      recentformList: [],
      currentRecentformPage: 1,
      totalformsPages: 0,
      recentpageformindex: 1,
      recentpageformsize: 10,
      SortProperty: "",
      SortOrder: 1,
      investigatorEmail: "",
      subjectIdSelected: "",
      showSidePopup: [[[false]]],
      templateList: [],
      visitFormObj: {},
      additionalFormObj:{},
      activityobject: {},
      observationValue: {},
      selectedVisit: {},
      selectedTemplate: "",
      sohowFormModal: false,
      sohowFormModalImminent: false,
      showChangeSchedule: false,
      showChangeActivity: false,
      showSdvModal: false,
      templateIdForSdv: null,
      formlist: [],
      CreateVideoCallSchedulePopUp: false,
      selectedPatientId: null,
      statusType: "",
      changeStatus: {
        studyId: "",
        visitNo: "",
        subjectNo: "",
        visitstatus: "",
      },
      changetemplateobj: {
        studyId: "",
        visitNo: "",
        subjectNo: "",
        visitstatus: "",
      },
      visitIndex: "",
      showObservationsLoading: {},
      categoryFlags: {},
      studyRef: null,
      selectedForm: "",
      studyInfo: "",
      selectedVisitName: "",
      formIndex: "",
      scheduleId: "",
      openedsitesarray: [],
      openedpatientsarray: [],
      openedformsarray: [],
      selectedPatientId: "",
      selectedVisitNo: "",
      showChangeTemplatePopover: false,
      vIndex: "",
      selectedScheduleId: "",
      showChangeTemplatePopover: "",
      selectedSiteCode: "",
      selectedPatno: "",
      showAssignForm: false,
      showAssignTemplate: false,
      ecrfformlist: [],
      referanceType: "",
      occuranceStartDate: "",
      totalOccurance: 0,
      templateName: "",
      templateId: "",
      additionalFormObj: {},
      hasadditionalforms: {},
      expandedAdditionalGroups: {},
      expandedAdditionalMain: {},
      additionalformchecked:{},
    };
  },
computed: {
    // Grouped additional forms: { patientId: { templateId: { name, forms[] } } }
    groupedAdditionalForms() {
      const grouped = {};
      
      for (const patientId in this.additionalFormObj) {
        const forms = this.additionalFormObj[patientId] || [];
        const byTemplate = {};

        forms.forEach(form => {
          const key = form.templateId;
          if (!byTemplate[key]) {
            byTemplate[key] = {
              templateName: form.templateName,
              forms: []
            };
          }
          byTemplate[key].forms.push(form);
        });

        grouped[patientId] = byTemplate;
      }

      return grouped;
    }
  },
  async mounted() {
    this.getstudyinfo();
    this.defaultdate = localStorage.getItem("dateformat");
    window.addEventListener("studyIdChanged", (event) => {
      this.getstudyinfo();
      this.getoverduevisits();
      this.getplannedvisits();
      this.getsites();
      this.getForms();
      this.GetRecentFormData();
    });
    await this.setroleprivileges();
    this.investigatorEmail = jwt_decode(store.getters.getIdToken);
    await this.getstudyinfo();
    this.getoverduevisits();
    this.getplannedvisits();
    await this.getsites();
    this.getForms();
    this.GetRecentFormData();
    this.restoretree();

  },
  unmounted() {
    store.dispatch("setopentreeforsubjectschedule", false);
  },
  methods: {
    showPopover(id) {
      document.getElementById(id)?.showPopover?.();
    },
    hidePopover(id) {
      document.getElementById(id)?.hidePopover?.();
    },
    
    toggleAdditionalMain(patientId) {
    // Toggle the main folder
    this.expandedAdditionalMain = {
      ...this.expandedAdditionalMain,
      [patientId]: !this.expandedAdditionalMain[patientId]
    };

    // If opening, load data if not already loaded
    if (!this.expandedAdditionalMain[patientId] === false) { // i.e., now opening
      if (!this.additionalFormObj[patientId]) {
        this.getAdditionalForms(patientId);
      }
    }

    // Optional: collapse all sub-groups when closing main
    if (!this.expandedAdditionalMain[patientId]) {
      this.expandedAdditionalGroups = {
        ...this.expandedAdditionalGroups,
        [patientId]: {} // clear all sub-expansions
      };
    }
  },
    toggleAdditionalGroup(patientId, templateId) {
    // Create a fresh copy to trigger reactivity
    const patientGroups = { 
      ...(this.expandedAdditionalGroups[patientId] || {}) 
    };

    // Toggle the value
    patientGroups[templateId] = !patientGroups[templateId];

    // Reassign the entire patient object — this forces Vue to react
    this.expandedAdditionalGroups = {
      ...this.expandedAdditionalGroups,
      [patientId]: patientGroups
    };
  },
    async restoretree() {
  // Run restore if flag is set OR if we actually have something to restore
  const hasAnything =
    (store.getters.getopenedsitesarraysubschedule || []).length ||
    (store.getters.getopenedpatientarraysubschedule || []).length ||
    (store.getters.getopenedformsarraysubschedule || []).length;

  const shouldRestore =
    store.getters.getopentreeforsubjectschedule || hasAnything;

  if (!shouldRestore) return;

  await this.restoresites();
  await this.restorpatients();
  await this.restoreforms();
},
  async restoresites() {
  const openedsitesarray = store.getters.getopenedsitesarraysubschedule || [];
  if (openedsitesarray.length) {
    const root = document.getElementById("study-name");
    if (root) root.checked = true;
  }

  // Load patients for each site first (correct order!), then expand checkbox
  for (const each of openedsitesarray) {
    await this.getpatient(each.siteId, each.index); // <-- real call, not a DOM event
    await this.$nextTick();
    await this.waitForCheckboxAndCheck(each.siteId); // expand the site branch
    await this.$nextTick();
  }
},
   async restorpatients() {
  const openedpatientsarray = store.getters.getopenedpatientarraysubschedule || [];

  for (const each of openedpatientsarray) {
    // Load visits for this patient
    await this.getVisits(each.patientId, each.index);

    // Expand the patient branch (CSS checkbox)
    await this.waitForCheckboxAndCheck(each.patientId);

    await this.$nextTick();
  }
},
async waitForCheckboxAndCheck(id) {
  await this.waitForElement(`#${CSS.escape(id)}`).catch(() => {});
  const el = document.getElementById(id);
  if (el && !el.checked) el.checked = true; // expand for CSS tree
},
findActivityIndex(subjectId, visitNo, visitIndex, activityid, activityorder) {
  const key = `${visitNo}_${subjectId}`;
  const arr = (this.activityobject[key]?.[visitIndex]?.data) || [];
  return arr.findIndex(a => a.activityId === activityid && a.activityOrder === activityorder);
},
  async restoreforms() {
  const opened = store.getters.getopenedformsarraysubschedule || [];
  if (!opened.length) return;

  // 1) Ensure visits (and activities) are loaded & expanded
  const visitEntries = opened.filter(x => !x.activityid);
  for (const e of visitEntries) {
    const visitCbId = `${e.sheduleId}${e.subjectId}`; // matches :id="visit.sheduleId + patient.patientId"
    await this.waitForCheckboxAndCheck(visitCbId);

    // Load activities for this visit
    await this.getactivities(e.subjectId, e.visitNo, e.visitName, e.visitIndex, e.sheduleId);
    await this.$nextTick();
  }

  // 2) Expand the specific activities and fetch their forms
  const activityEntries = opened.filter(x => x.activityid);
  for (const e of activityEntries) {
    const visitKey = `${e.visitNo}_${e.subjectId}`;

    // Make sure activities are present for this visit
    if (!this.activityobject[visitKey] || !this.activityobject[visitKey][e.visitIndex]) {
      await this.getactivities(e.subjectId, e.visitNo, e.visitName, e.visitIndex, e.sheduleId);
      await this.$nextTick();
    }

    const idx = this.findActivityIndex(e.subjectId, e.visitNo, e.visitIndex, e.activityid, e.activityorder);

    // Expand the activity branch (CSS checkbox)
    const activityCbId = `${e.activityid}${e.visitNo}${e.activityorder}`;
    await this.waitForCheckboxAndCheck(activityCbId);

    // Load forms under this activity
    await this.getFormsByVisit(
      e.subjectId,
      e.visitNo,
      e.visitName,
      e.visitIndex,
      e.sheduleId,
      idx < 0 ? 0 : idx,
      e.activityid,
      e.activityorder
    );

    await this.$nextTick();
  }
},
   waitForElement(selector, timeout = 4000) {
  return new Promise((resolve, reject) => {
    const start = performance.now();
    const check = () => {
      if (document.querySelector(selector)) return resolve();
      if (performance.now() - start > timeout) return reject(new Error(`Element ${selector} not found`));
      requestAnimationFrame(check);
    };
    check();
  });
},
    async setroleprivileges() {
      this.roleprivileges = await store.getters.getRolesprivilegeData;
    },
    async openFormsModal(visitNo, patientId, studyId) {
      await this.listvisitForms(visitNo, patientId, studyId);
      this.sohowFormModal = true;
    },
    async openImminentFormsModal(visitNo, patientId, studyId) {
      await this.listvisitForms(visitNo, patientId, studyId);
      this.sohowFormModalImminent = true;
    },
    async closeFormsModal() {
      this.sohowFormModal = false;
    },
    async closeImminentFormsModal() {
      this.sohowFormModalImminent = false;
    },
    openVideoCallSchedulePopup(patientId) {
      this.selectedPatientId = patientId; // Set the selected patient ID
      console.log("Patient id is", this.selectedPatientId);
      this.CreateVideoCallSchedulePopUp = true; // Open the popup
    },
    async openAssignFormModal(patientId, visitName, visitNo, vIndex, sheduleId, siteCode, patientNo) {
      this.selectedPatientId = patientId;
      this.selectedVisitName = visitName;
      this.selectedVisitNo = visitNo;
      this.vIndex = vIndex;
      this.selectedScheduleId = sheduleId;
      this.selectedSiteCode = siteCode;
      this.selectedPatno = patientNo;
      this.showAssignForm = true;
      await this.getEPROFormsList();
    },
    async closeAssignFormModal() {
      this.showAssignForm = false;
      await this.getFormsByVisit(this.selectedPatientId, this.selectedVisitNo, this.selectedVisitName, this.vIndex, this.selectedScheduleId, this.selectedSiteCode, this.selectedPatno);
    },
    // async viewForm(formId, isPatientVisit) {
    //   this.$router.push(`/editForm/submitForm/${formId}/${isPatientVisit}`);
    // },
    async listvisitForms(visitNo, patientId, studyId) {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseUrl}getfromsbyvisit?studyId=${studyId}&patientID=${patientId}&visitNo=${visitNo}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          console.log("Visit form list is...", res);
          this.formlist = res.data.data;
          console.log("formlist", this.formlist);
        })
        .catch((err) => console.log(" error in getting visit forms...", err));
    },
    async gotoform(singlevisit, autosubjectid, autositecode) {
      if (singlevisit.visitStatus == "Withdrawn") {
        alert("The form has already been withdrawn.");
      } else {
        console.log("singlevisit", singlevisit);
        await store.dispatch("setautofillsiteid", autositecode);
        await store.dispatch("setautofillsubjectid", autosubjectid);
        await store.dispatch("setautofillenabled", "true");
        if (singlevisit.formId == null || singlevisit.formId == "") {
          let tempvar = {
            Siteid: singlevisit.siteId,
            Subject_id: singlevisit.patientId,
            Visitname: singlevisit.visitName,
            Visitno: singlevisit.visitNo,
            sheduleId: singlevisit.sheduleId,
          };
          await store.dispatch("commitvisitdetails", tempvar);
          console.log("IspatientVist?", singlevisit.isPatientVisit);
          if (singlevisit.templateId == null || singlevisit.templateId == "") {
            alert(this.$t("navigations.no template assigned"));
          } else {
            this.$router.push(
              `/form/${singlevisit.isPatientVisit}/${singlevisit.templateId}/${singlevisit.studyId}/0 `
            );
          }

          // this.$router.push(`/form/${visits.templateId}/${visits.studyId}/${visits.visitid}`);
        } else {
          this.$router.push(
            `/editForm/subject_schedule/${singlevisit.formId}/${singlevisit.isPatientVisit} `
          );
        }
      }
    },
    async gotofillform(visits, autosubjectid, autositecode) {
      if (!this.selectedTemplate) {
        alert("Please select a form.");
        return;
      }
      console.log("gotofillform visits", visits);
      await store.dispatch("setautofillsiteid", autositecode);
      await store.dispatch("setautofillsubjectid", autosubjectid);
      await store.dispatch("setautofillenabled", "true");
      const template = this.templateList.find(
        (t) => t.templateId === this.selectedTemplate
      );
      let tempvar = {
        Siteid: visits.siteId,
        Subject_id: this.subjectIdSelected,
        Visitname: visits.visitName,
        Visitno: visits.visitNo,
        sheduleId: visits.sheduleId,
        Template_name: template.templateName,
        Visit_id: visits.visitId,
        ActivityScheduleId: visits.actScheduleId,
        ActivityId: visits.activityId,
      };
      await store.dispatch("commitvisitdetails", tempvar);
      localStorage.setItem("visitDetails", JSON.stringify(tempvar));
      console.log("tempvar is ", tempvar);
      await store.dispatch("setfrompatientschedule", "frompatientschedule");
      this.$router.push({
        path: `/form/${visits.isPatientVisit}/${this.selectedTemplate}/${visits.studyId}/0`,
        query: {
          tempObj: encodeURIComponent(JSON.stringify(tempvar)),
        },
      });
    },
    async goToForms() {
      if (visits.formId == null || visits.formId == "") {
        this.gotoform();
      } else {
        this.EditForm();
      }
    },
    async EditForm(formId, isPatientVisit) {
      this.$router.push(`/editForm/subject_schedule/${formId}/${isPatientVisit}`);
    },
    async goTovisitTemplate(lists, patientId) {
      if (lists[0].visitStatus == "Withdrawn") {
        alert("The form has already been withdrawn.");
      } else {
        localStorage.setItem("patid", patientId);
        console.log("List visit is ", lists);
        console.log("TEMPLATE ID IS", await lists[0].templateId, await lists);
        await store.dispatch("setautofillsiteid", lists[0].siteCode);
        await store.dispatch("setautofillsubjectid", lists[0].patientNo);
        await store.dispatch("setautofillenabled", "true");
        if (
          ((await lists[0].templateId) != null &&
            (await lists[0].templateId) != "null" &&
            (await lists[0].formId) == null) ||
          (await lists[0].formId) == "null"
        ) {
          let tempvar = {
            Siteid: lists[0].siteId,
            Subject_id: lists[0].patientId,
            Visitname: lists[0].visitName,
            Visitno: lists[0].visitNo,
            sheduleId: lists[0].sheduleId,
          };

          await store.dispatch("commitvisitdetails", tempvar);
          this.$router.push(
            `/form/${lists[0].isPatientVisit}/${lists[0].templateId}/${lists[0].studyId}/0 `
          );
        } else if (
          (await lists[0].templateId) != null &&
          (await lists[0].templateId) != "null" &&
          (await lists[0].formId) != null &&
          (await lists[0].formId) != "null"
        ) {
          this.$router.push(
            `/editForm/subject_schedule/${lists[0].formId}/${lists[0].isPatientVisit} `
          );
        } else if (
          (await lists[0].templateId) == null ||
          (await lists[0].templateId) == "null"
        ) {
          alert(this.$t("navigations.no template assigned"));
        }
      }
    },
    async goToTemplate(isPatientVisit, templateid, visitid) {
      await store.dispatch("setautofillsiteid", "");
      await store.dispatch("setautofillsubjectid", "");
      await store.dispatch("setautofillenabled", "false");
      const studyid = store.getters.getStudyIs;
      this.$router.push(
        `/form/${isPatientVisit}/${templateid}/${studyid}/${visitid}`
      );
    },
    async isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    async viewform(id, siteid, subid) {
      console.log("siteid, subid = ", siteid, subid);
      if (siteid != null || subid != null) {
        console.log("siteid, subid = ", siteid, subid);
        await store.dispatch("setautofillenabled", "true");
      } else {
        await store.dispatch("setautofillenabled", "false");
      }
      this.$router.push(`/showform/subject_schedule/${id}/0`);
      //this.$router.push(`/editForm/subject_schedule/${id}/0`);
    },
    async setFontSize(el) {
      var fontSize = el.val();

      if (isNumber(fontSize) && fontSize >= 0.5) {
        $("body").css({ fontSize: fontSize + "em" });
      } else if (fontSize) {
        el.val("1");
        $("body").css({ fontSize: "1em" });
      }
    },
    async itemClick(node) {
      console.log(node.model.text + " clicked !");
    },

    filter(data) {
      if (data) {
        return moment(data)
          .utc()
          .format(this.defaultdate);
      }
      console.log(data);
    },
    filterMonth(date) {
      if (date) {
        //console.log("dateeeeeeeeee",date)
        return moment(date).format("DD-MMM-YYYY");
      }
    },
    SortSelectforms(sortProp, id) {
      console.log("SortPropChanged");
      const selectedElement = document.getElementById(id);
      const selectedElementID = document.getElementById(id).id;
      if (sortProp != null && id == selectedElementID) {
        this.sortDesc = !this.sortDesc;
        if (this.SortOrder == 0) {
          if (selectedElement.classList.contains("sortDesc")) {
            return;
          } else if (selectedElement.classList.contains("sortAsc")) {
            selectedElement.classList.remove("sortAsc");
            selectedElement.classList.add("sortDesc");
          } else selectedElement.classList.add("sortDesc");
        } else {
          if (selectedElement.classList.contains("sortDesc")) {
            selectedElement.classList.remove("sortDesc");
            selectedElement.classList.add("sortAsc");
          } else if (selectedElement.classList.contains("sortAsc")) {
            return;
          } else selectedElement.classList.add("sortAsc");
        }
      }
      this.pageindex = 1;
      this.currentPage = 1;
      this.SortProperty = sortProp;
      this.SortOrder = this.SortOrder == 0 ? 1 : 0;
      this.GetRecentFormData();
    },
    async GetRecentFormData() {
      const idtoken = store.getters.getIdToken;
      const stdid = store.getters.getStudyIs;
      await axios
        .get(
          // `${this.baseapi}/forms/forms/getpaginatedrecentforms?studyId=${stdid}&userEmail=${this.investigatorEmail.email}&pageindex=${this.recentpageformindex}&pagesize=${this.recentpageformsize}&SortProperty=${this.SortProperty}&SortOrder=${this.SortOrder}&api-version=1.0`,
          // &userEmail=${this.investigatorEmail.email}
          `${this.baseapi}/forms/ecrfsource/getpaginatedrecentecrf?studyId=${stdid}&pageindex=${this.recentpageformindex}&pagesize=${this.recentpageformsize}&SortProperty=${this.SortProperty}&SortOrder=${this.SortOrder}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data) {
            console.log("study id iSssssssssss", stdid);
            this.recentformList = response.data.results;
            console.log("Recent form table data", response.data);
            this.totalrecentCount = response.data.totalCount;
            // if(response.data.totalCount>30)
            // {
            //   this.totalrecentCount=30
            // }
            this.totalformsPages = parseInt(
              this.totalrecentCount / this.recentpageplannedsize
            );
            if (this.totalrecentCount % this.recentpageplannedsize != 0) {
              console.log(
                "In iffffffffff",
                this.totalrecentCount % this.recentpageplannedsize
              );
              this.totalformsPages = this.totalformsPages + 1;
            }

            console.log(
              "PAGES VALUEEEE",
              this.totalformsPages,
              this.totalrecentCount
            );
          } else {
            console.log("no forms found");
          }
        })

        .catch((err) => {
          console.log(err);
        });
    },
    SortSelected(sortProp, id) {
      console.log("SortPropChanged");
      const selectedElement = document.getElementById(id);
      const selectedElementID = document.getElementById(id).id;
      if (sortProp != null && id == selectedElementID) {
        if (this.IsDesc == true) {
          if (selectedElement.classList.contains("sortDesc")) {
            return;
          } else if (selectedElement.classList.contains("sortAsc")) {
            selectedElement.classList.remove("sortAsc");
            selectedElement.classList.add("sortDesc");
          } else selectedElement.classList.add("sortDesc");
        } else {
          if (selectedElement.classList.contains("sortDesc")) {
            selectedElement.classList.remove("sortDesc");
            selectedElement.classList.add("sortAsc");
          } else if (selectedElement.classList.contains("sortAsc")) {
            return;
          } else selectedElement.classList.add("sortAsc");
        }
      }
      this.pageindex = 1;
      this.currentPage = 1;
      this.sProp = sortProp;
      this.IsDesc = this.IsDesc == true ? false : true;
      this.getoverduevisits();
    },
    async getoverduevisits() {
      this.overduevisits = [];
      const currentstudyid = store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseapi}/management/patientschedule/getshedules?Investigator=${this.investigatorEmail.name}&StudyId=${currentstudyid}&VisitStatus=Overdue&PageNo=${this.pageoverdueindex}&ItemCount=${this.pageoverduesize}&sortprop=${this.sProp}&isDes=${this.IsDesc}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.overduevisits = res.data.data;
          console.log("Overdue visits are", this.overduevisits);
          this.totaloverdueCount = res.data.totalCount;
          this.totaloverduePages = parseInt(
            res.data.totalCount / this.pageoverduesize
          );
          if (this.totaloverdueCount % this.pageoverduesize != 0) {
            this.totaloverduePages = this.totaloverduePages + 1;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    SortSelect(sortProp, id) {
      console.log("SortPropChanged");
      const selectedElement = document.getElementById(id);
      const selectedElementID = document.getElementById(id).id;
      if (sortProp != null && id == selectedElementID) {
        if (this.IsDesc == true) {
          if (selectedElement.classList.contains("sortDesc")) {
            return;
          } else if (selectedElement.classList.contains("sortAsc")) {
            selectedElement.classList.remove("sortAsc");
            selectedElement.classList.add("sortDesc");
          } else selectedElement.classList.add("sortDesc");
        } else {
          if (selectedElement.classList.contains("sortDesc")) {
            selectedElement.classList.remove("sortDesc");
            selectedElement.classList.add("sortAsc");
          } else if (selectedElement.classList.contains("sortAsc")) {
            return;
          } else selectedElement.classList.add("sortAsc");
        }
      }
      this.pageindex = 1;
      this.currentPage = 1;
      this.sProp = sortProp;
      this.IsDesc = this.IsDesc == true ? false : true;
      this.getplannedvisits();
    },
    async getplannedvisits() {
      this.plannedvisits = [];
      const currentstudy = store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;

      await axios
        .get(
          `${this.baseapi}/management/patientschedule/getshedules?Investigator=${this.investigatorEmail.name}&StudyId=${currentstudy}&VisitStatus=Imminent&PageNo=${this.pageplannedindex}&ItemCount=${this.pageplannedsize}&sortprop=${this.sProp}&isDes=${this.IsDesc}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.plannedvisits = res.data.data;
          console.log("Imminent visits are", this.plannedvisits);
          this.totalplannedCount = res.data.totalCount;
          this.totalplannedPages = parseInt(
            res.data.totalCount / this.pageplannedsize
          );
          if (this.totalplannedCount % this.pageplannedsize != 0) {
            this.totalplannedPages = this.totalplannedPages + 1;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getsites() {
      const currentstudyid = store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseapi}/management/site/getallsitesbyuser?studyId=${currentstudyid}&getAll=false&sortProperty=siteCode&IsDes=false`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.sites = res.data;
          console.log("Sites are", this.sites);
          console.log("Current study is", currentstudyid);
          console.log(idtoken);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getpatient(siteId, index) {
      let opensites = {
        "siteId": siteId,
        "index": index
      };
      const existingIndex = this.openedsitesarray.findIndex(
        item => item.siteId === siteId && item.index === index
      );

      if (existingIndex !== -1) {
        this.openedsitesarray.splice(existingIndex, 1);
      }
      else {
        this.openedsitesarray.push(opensites);
      }
      await store.dispatch("setopenedsitesarraysubschedule", this.openedsitesarray);
      this.patientLists[index] = [];
      const idtoken = store.getters.getIdToken;
      const currentstudyid = store.getters.getStudyIs;
      await axios
        .get(
          `${this.baseapi}/management/patient/listpatient?SiteId=${siteId}&Studyid=${currentstudyid}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then(async (res) => {
          let data = res.data.results;
          await data.forEach((patientdata) => {
            this.visitobj[patientdata.patientId] = [];
          });
          this.patientLists[index] = data;
          console.log("patient list is", this.visitobj);
        });
      // await this.setvisitobj(this.patientLists[index]);
    },
    async setvisitobj(data) {
      console.log("set visit function");
      console.log("patient list is", data);
      data.forEach((patientdata) => {
        this.visitobj[patientdata.patientId] = [];
      });
      console.log(this.visitobj);
    },
    async getVisits(patientId, index) {
      let openedvisit = {
        "patientId": patientId,
        "index": index
      }
      const existingIndex = this.openedpatientsarray.findIndex(
        item => item.patientId === patientId && item.index === index
      );

      if (existingIndex !== -1) {
        // It’s already in the array → remove it
        this.openedpatientsarray.splice(existingIndex, 1);
      } else {
        this.openedpatientsarray.push(openedvisit);
      }
      await store.dispatch("setopenedpatientarraysubschedule", this.openedpatientsarray);
      this.visitobj[patientId][index] = [];
      const idtoken = store.getters.getIdToken;
      console.log("patient ID is", patientId);

      await axios
        .get(
          `${this.baseapi}/management/patientschedule/getpatientshedule?patientID=${patientId}&ItemCount=500&sortprop=VisitNo`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.visitobj[patientId][index] = res.data.data;
          const hasAdditional = res.data.data.some(r => r?.visitNo == null);
          console.log("hasAdditional",hasAdditional);
          this.hasadditionalforms[patientId]= hasAdditional;
          console.log("The visit list is", this.visitobj);
        })
        .catch((err) => {
          console.log("error is", err);
        });
      this.displayTable = true;
    },
    // async getForms()
    // {
    //   const idtoken = store.getters.getIdToken;
    //   const currentstudyid = store.getters.getStudyIs;
    //   await axios
    //   .get(
    //     `${this.baseapi}/management/visit/listvisit?StudyId=${currentstudyid}&pageindex=${this.pageformindex}&pagesize=${this.pageformsize}`,
    //     {
    //       headers: {
    //         Authorization: "Bearer " + idtoken,
    //         "Content-Type": "application/json",
    //       },
    //     }
    //   )
    //   .then((res) => {
    //       this.formList = res.data.results;
    //       console.log("The form list is",this.formList)
    //       this.totalformCount = res.data.totalCount;
    //       this.totalformPages=parseInt(this.totalformCount / this.pageformsize)
    //        if((this.totalformCount % this.pageformsize) !=0){
    //         this.totalformPages = this.totalformPages+1
    //       }
    //   })
    //   .catch((err) =>{
    //       console.log("error is" , err);
    //   })
    //   this.displayTable=true
    // },
    loadTemplate: function (page) {
      this.currentTemplatePage = page;
      this.getForms();
    },
    async getForms() {
      const currentstudyid = store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
      const head = {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      };
      axios
        .get(
          `${this.baseapi}/forms/template/listtemplate?IsPrivileged=true&StudyID=${currentstudyid}&Status=Approved&pageindex=${this.currentTemplatePage}&pagesize=5&SortProperty=templateName&SortOrder=0`,
          head
        )
        .then((res) => {
          console.log("template details ", res.data);
          this.formList = res.data.results;

          let totalCount = res.data.totalCount;
          this.totalTemplatePages = parseInt(totalCount / 5);
          if (totalCount % 5 != 0) {
            this.totalTemplatePages = this.totalTemplatePages + 1;
          }
        })
        .catch((err) => console.log("error in get study", err));
    },
    async listTemplate() {
      const idtoken = store.getters.getIdToken;
      const currentstudyid = store.getters.getStudyIs;
      await axios
        .get(
          `${this.baseapi}/forms/template/listtemplate?IsPrivileged=true&Status=Approved&StudyID=${currentstudyid}&&SortProperty=templateName&SortOrder=0 `,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          console.log("Study template list is...", res.data);
          this.templateList = res.data.results;
        })
        .catch((err) => console.log("error while getting template list", err));
    },
    toggleSidePopup(sIndex, pIndex, vIndex) {
      console.log("Toggle", sIndex, this.showSidePopup);

      // Initialize arrays if they don't exist
      if (!this.showSidePopup[sIndex]) {
        this.showSidePopup[sIndex] = [];
      }
      if (!this.showSidePopup[sIndex][pIndex]) {
        this.showSidePopup[sIndex][pIndex] = [];
      }

      // Toggle the value
      if (typeof this.showSidePopup[sIndex][pIndex][vIndex] === "undefined") {
        this.showSidePopup[sIndex][pIndex][vIndex] = false;
      }
      this.showSidePopup[sIndex][pIndex][vIndex] = !this.showSidePopup[sIndex][
        pIndex
      ][vIndex];
    },
    closeSidePopup(sIndex, pIndex, vIndex) {
      if (this.showSidePopup[sIndex] && this.showSidePopup[sIndex][pIndex]) {
        this.showSidePopup[sIndex][pIndex][vIndex] = false;
      }
    },
    activityInputId(sa, patient, visit) {
    return `act-${sa.activityId}-${patient.patientId}-${visit.visitNo}-${sa.activityOrder}`;
  },
   formInputId(singlevisit, pIndex, vIndex, activityindex) {
    return `form-${singlevisit.sheduleId}-${pIndex}-${vIndex}-${activityindex}`;
  },
    async openModal(visit, subjectId, siteCode, visitstatus) {
      if (visit.withdrawnDate) {
        alert("You cannot add new forms to a withdrawn visit");
      } else {
        console.log("Open Modal", visit, subjectId, siteCode);
        this.selectedVisit.visit = visit;
        this.selectedVisit.subjectId = subjectId;
        this.selectedVisit.siteCode = siteCode;
        console.log("selected visit is ", this.selectedVisit);
        // this.selectedmodeltemplate = "";
        // this.selectedvisitid = visitid;
        await this.listTemplate();
        const modalWrapper = document.querySelector(".modal-wrapper");
        modalWrapper.classList.add("active");
    
      }
    },

    closeModal() {
      // this.selectedmodeltemplate = "";
      const modalWrapper = document.querySelector(".modal-wrapper");
      modalWrapper.classList.remove("active");
    },
  closeSdvModal() {
  this.showSdvModal = false;
},

    async getstudyinfo() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseapi}/management/study/getbyid?id=${store.getters.getStudyIs}&api-version=1.0`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.studyInfo = res.data;
          this.studyRef = res.data.studyRef;
          console.log(this.studyRef, "Study ref")
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getAdditionalForms(subjectId) {
      if(this.additionalformchecked[subjectId]){
        this.additionalformchecked[subjectId] = !this.additionalformchecked[subjectId];
      }
      else{
        this.additionalformchecked[subjectId] = true;
      }
      const idtoken = this.$store.getters.getIdToken;
      const stdid = this.$store.getters.getStudyIs;
      try {
        const res = await axios.get(
          `${this.baseapi}/management/patientschedule/getfromsbyvisit`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
            params: {
              studyId: stdid,
              patientID: subjectId,
              visitNo: null,
            },
          }
        );
        // Vue reactivity: use Vue.set or assign directly if using Vue 3
        this.additionalFormObj[subjectId] = res.data.data;
        
        console.log("data is ", this.additionalFormObj[subjectId]);
      } catch (err) {
        console.log("error while getting visit forms list", err);
      }
    },
    async getFormsByVisit(
  subjectId,
  visitNo,
  visitName,
  visitIndex,
  sheduleId,
  activityindex,
  activityid,
  activityorder
) {
  // (unchanged) toggle checkbox safely
  if (activityid != null && activityorder != null) {
    const cbId = `${activityid}${subjectId}${visitNo}${activityorder}`;
    const el = document.getElementById(cbId);
    if (el) el.checked = !el.checked;
  }

  // (unchanged) persist open state
  const opened = { sheduleId, subjectId, visitNo, visitName, visitIndex };
  if (activityid != null && activityorder != null) {
    opened.activityid = activityid;
    opened.activityorder = activityorder;
  }
  const existingIndex = this.openedformsarray.findIndex(item =>
    item.sheduleId === sheduleId &&
    item.subjectId === subjectId &&
    item.visitNo === visitNo &&
    item.visitName === visitName &&
    item.visitIndex === visitIndex &&
    (
      (opened.activityid == null && item.activityid == null) ||
      (opened.activityid != null &&
       item.activityid === opened.activityid &&
       item.activityorder === opened.activityorder)
    )
  );
  if (existingIndex !== -1) this.openedformsarray.splice(existingIndex, 1);
  else this.openedformsarray.push(opened);
  await store.dispatch("setopenedformsarraysubschedule", this.openedformsarray);

  // (unchanged) data prep
  const key = visitNo + subjectId;
  if (!this.visitFormObj[key]) this.visitFormObj[key] = [];
  if (activityindex == null && activityid != null) {
    activityindex = this.findActivityIndex(subjectId, visitNo, visitIndex, activityid, activityorder);
    if (activityindex < 0) activityindex = 0;
  }
  if (activityindex == null) activityindex = 0;
  this.visitFormObj[key][activityindex] = [];

  // --- CHANGED PART: build request without `??` and without manual string concat
  const idtoken = store.getters.getIdToken;
  const stdid = store.getters.getStudyIs;

  try {
    const res = await axios.get(
      `${this.baseapi}/management/patientschedule/getfromsbyvisit`,
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
        params: {
          studyId: stdid,
          patientID: subjectId,
          visitNo: visitNo,
          visitName: visitName,
          activityId: activityid == null ? "" : activityid,
          activityOrder: activityorder == null ? "" : activityorder,
        },
      }
    );
    this.visitFormObj[key][activityindex] = res.data.data;
    console.log("data is ", this.visitFormObj[key][activityindex]);
  } catch (err) {
    console.log("error while getting visit forms list", err);
  }
},
    async getactivities(subjectId, visitNo, visitName, visitIndex, sheduleId, siteCode, patientNo) {
      const visitKey = `${visitNo}_${subjectId}`;
      this.subjectIdSelected = subjectId;
      const openedforms = { sheduleId, subjectId, visitNo, visitName, visitIndex };

      const existingIndex = this.openedformsarray.findIndex(
        item => item.sheduleId === sheduleId && item.subjectId === subjectId &&
          item.visitNo === visitNo && item.visitName === visitName &&
          item.visitIndex === visitIndex
      );

      if (existingIndex !== -1) {
        this.openedformsarray.splice(existingIndex, 1);
      } else {
        this.openedformsarray.push(openedforms);
      }

      await store.dispatch("setopenedformsarraysubschedule", this.openedformsarray);
      this.visitIndex = visitIndex;

      if (!this.activityobject[visitKey]) {
        this.activityobject[visitKey] = [];
      }

      this.observationValue[visitKey] = false;
      this.activityobject[visitKey][visitIndex] = [];

      const idtoken = store.getters.getIdToken;
      const currentstudyid = store.getters.getStudyIs;
      try {
        const res = await axios.get(
          `${this.baseapi}/management/patientschedule/getactivitynames?subjectId=${subjectId}&visitNo=${visitNo}&studyId=${currentstudyid}`,
          {
            headers: {
              Authorization: `Bearer ${idtoken}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.activityobject[visitKey][visitIndex] = res.data.data;
         this.toggleObservationFolder(siteCode, patientNo, visitName, visitNo, subjectId);
      } catch (err) {
        console.error("Error while getting visit forms list", err);
      }
    },




    async listVisitForms(siteId, subjectId, visitNo) {
      this.visitFormObj[visitNo] = [];
      const idtoken = store.getters.getIdToken;
      const stdid = store.getters.getStudyIs;
      await axios
        .get(
          `${this.baseapi}/forms/forms/getformsbyids?studyid=${stdid}&siteid=${siteId}&subjectid=${subjectId}&visitno=${visitNo}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.visitFormObj[visitNo] = res.data;
          console.log("Visit form list is...", this.visitFormObj);
          console.log("data is ", this.visitFormObj[visitNo]);
        })
        .catch((err) =>
          console.log("error while getting visit forms list", err)
        );
    },
    selectDocument(siteCode, patientId, doc, visitName, subjectId, siteId) {
      sessionStorage.setItem("FHIRpatient", JSON.stringify(doc));
      this.$router.push(
        `/FHIRpage/${siteCode}/${patientId}/${visitName}/${subjectId}/${siteId}`
      );
    },
    filterTimeFormat(data) {
      if (data) {
        return data.replace(/:00\+00:00$/, "");
      }
    },
    async toggleObservationFolder(
      siteCode,
      subjectCode,
      visitCode,
      visitNo,
      patientId
    ) {

      await axios
        .get(
          `${this.baseapi}/fhir-service/fhir/observations?StudyRef=${this.studyRef}&SiteCode=${siteCode}&Subjects=${subjectCode}&VisitCodes=${visitCode}`
        )
        .then((res) => {
          if (res.data && res.data.length != 0 && res.data != 'Visits Not Found') {
            this.observationValue[visitNo + patientId] = true
            this.categoryFlags[visitNo + patientId] = Object.values(
              res.data.reduce((acc, doc) => {
                const document = doc.resource;
                const id = doc.resource.id;
                const category = doc.resource.category[0].coding[0].display;
                const codeText = doc.resource.code.text
                  ? doc.resource.code.text
                  : doc.resource.code.coding[0].display; // Handle missing `text`
                const effectiveDateTime = doc.resource.effectiveDateTime || null;

                // If the category already exists, add the code to its array
                if (!acc[category]) {
                  acc[category] = {
                    category: category,
                    code: [],
                    effectiveDateTime: [],
                    flag: false,
                    document: [],
                    id: [],
                    idSet: new Set(), // Track unique IDs
                  };
                } // Push codeText to the array (allowing duplicates)
                if (id && !acc[category].idSet.has(id)) {
                  acc[category].idSet.add(id);
                  acc[category].id.push(id);

                  if (codeText) {
                    acc[category].code.push(codeText);
                  }
                  if (effectiveDateTime) {
                    acc[category].effectiveDateTime.push(effectiveDateTime);
                  }
                  if (document) {
                    acc[category].document.push(document);
                  }
                }

                return acc;
              }, {})
            );
            const vitalSignsCategory = this.categoryFlags[
              siteCode + subjectCode
            ].find(
              (category) =>
                category.category === "Vital Signs" ||
                category.category === "vital signs"
            );
            let latestVitalSigns = [];

            if (vitalSignsCategory) {
              const {
                code,
                document,
                unit,
                effectiveDateTime,
              } = vitalSignsCategory;

              // Combine code and effectiveDateTime into a single array of objects
              const combined = code.map((c, index) => ({
                code: c,
                value:
                  c == "Blood Pressure"
                    ? `${document[index].component[1].valueQuantity.value}/${document[index].component[2].valueQuantity.value}`
                    : c == "Body height" ||
                      c == "Body weight" ||
                      c == "Body Temperature"
                      ? document[index].valueQuantity.value
                      : "",
                unit:
                  c == "Blood Pressure"
                    ? document[index].component[1].valueQuantity.unit
                    : c == "Body height" ||
                      c == "Body weight" ||
                      c == "Body Temperature"
                      ? document[index].valueQuantity.unit
                      : "",
                effectiveDateTime: effectiveDateTime[index], // Convert to Date for sorting
              }));
              // Sort by effectiveDateTime in descending order
              combined.sort((a, b) => b.effectiveDateTime - a.effectiveDateTime);

              // Extract the latest unique code entries
              const seenCodes = new Set();
              const latestVitalSigns = combined
                .filter((entry) => {
                  if (!seenCodes.has(entry.code)) {
                    seenCodes.add(entry.code);
                    return true;
                  }
                  return false;
                })
                .map((entry) => ({
                  code: entry.code,
                  value: entry.value,
                  unit: entry.unit,
                  effectiveDateTime: entry.effectiveDateTime, // Convert back to string if needed
                }));
              this.vitalSignsList = latestVitalSigns;
            }
          }
          else {
            this.observationValue[visitNo + patientId] = false
          }

        })
        .catch((err) => {
          console.log("Error", err);
        });
    },
    async closePopover(id) {
      document.getElementById(id)
        ? document.getElementById(id).hidePopover()
        : null;
    },
    async openChangeStatusmodalforactivity(
      actScheduleId,
      status,
      patientId,
      visitNo,
      visitName,
      vIndex,
      sheduleId,
      popoverId
    ) {
      await this.closePopover(popoverId);
      this.activitystatusreload.patientId = patientId;
      this.activitystatusreload.visitNo = visitNo;
      this.activitystatusreload.visitName = visitName;
      this.activitystatusreload.sheduleId = sheduleId;
      this.activitystatusreload.vIndex = vIndex;
      this.selectedActivityid = actScheduleId;
      this.currentactivitystatus = status;
      this.showChangeActivity = true;
    },
    async closeChangeactivityModal() {
      this.showChangeActivity = false;
    },
    async closeAssignSdvModal() {
      this.showSdvModal = false;
    },
    async changedactivityStatus(activitystatusreload){
      this.getactivities(
                                activitystatusreload.patientId,
                                activitystatusreload.visitNo,
                                activitystatusreload.visitName,
                                activitystatusreload.vIndex,
                                activitystatusreload.sheduleId,
                              );
          this.showChangeActivity = false;
    },
    async assignSdv( formId, templateId, popoverId) {
      // Set modal props and open the Assign SDV modal
      await this.closePopover(popoverId);
      this.selectedForm = formId || null;
      this.templateIdForSdv = templateId || null;
      console.log("Assign SDV modal opened with:",formId);
      this.showSdvModal = true;
    },
    async openChangeStatusmodal(
      studyId,
      visitNo,
      patientId,
      status,
      index,
      statusType,
      id,
      visitName,
      formStatus,
      formId,
      scheduleId
    ) {
      await this.closePopover(id);
      this.selectedForm = formId;
      this.scheduleId = scheduleId;
      this.statusType = statusType;
      this.changeStatus = {
        studyId: studyId,
        visitNo: visitNo,
        subjectId: patientId,
        visitstatus: statusType == "Visit" ? status : formStatus,
      };
      this.formIndex = index;
      this.selectedVisitName = visitName;
      this.visitIndex = index;
      this.showChangeSchedule = true;
    },
    closeModalchangetemolate() {
      this.showChangeTemplateModal = false;
    },
    async ChangeTemplatePopup(
      studyId,
      visitNo,
      patientId,
      status,
      index,
      statusType,
      popoverId,
      visitName,
      formStatus,
      scheduleId,
      templateId
    ) {
      await this.closePopover(popoverId);
      await this.listTemplate();
      this.selectedVisitName = visitName;

      this.changetemplateobj = {
        studyId: studyId,
        visitNo: visitNo,
        subjectId: patientId,
        visitstatus: statusType == "Visit" ? status : formStatus,
      };

      this.visitIndex = index;
      this.selectedScheduleId = scheduleId;

      // if (templateId && this.templateList.some(t => t.templateId === templateId)) {
      // this.selectedTemplate = templateId;
      if (templateId != null && templateId != "null" && templateId != undefined) {
        this.temptemplatelist = this.templateList.filter(t => t.templateId != templateId);
        this.selectedTemplate = templateId;
      } else {
        this.selectedTemplate = "";
      }

      this.showChangeTemplateModal = true;
    },

    async assignTemplate() {
      if (!this.selectedTemplate) {
        alert(this.$t('navigations.please select a form'));
        return;
      }
      const idtoken = store.getters.getIdToken;
      try {
        await axios.put(
          `${this.baseapi}/management/patientschedule/templateupdate?TemplateId=${this.selectedTemplate}&SheduleID=${this.selectedScheduleId}`, {},
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        ).then((res) => {
          if (res.data === "Template Not Found") {
            alert(this.$t("navigations.template not found"));
          } else {
            alert(this.$t('navigations.template assigned successfully'))
          }
        });
        this.selectedTemplate = "";
        this.showChangeTemplateModal = false;
        await this.getFormsByVisit(
          this.changetemplateobj.subjectId,
          this.changetemplateobj.visitNo,
          this.selectedVisitName,
          this.visitIndex
        );
        // Refresh forms for the updated schedule
        // Refresh forms for the updated schedule
        // if (

        //   this.selectedVisit &&
        //   this.selectedVisit.visit &&
        //   this.selectedVisit.subjectId &&
        //   this.selectedVisit.visit.visitNo &&
        //   this.selectedVisit.visit.studyId
        // ) {
        //   await this.getFormsByVisit(
        //     this.selectedVisit.subjectId,
        //     this.selectedVisit.visitNo,
        //     this.selectedVisitName,

        //   );
        // } else {
        //   // fallback: reload the page if visit info is not available
        //   // window.location.reload();
        // }
      } catch (err) {
        alert(err);
      }
    },
    async closeChangeScheduleModal() {
      this.showChangeSchedule = false;
    },
    popoverId(svisit, sIndex, pIndex, vIndex) {
      return `${svisit}-${sIndex}-${pIndex}-${vIndex}`;
    },
    async changedStatus() {
      console.log("inside change status", this.statusType);
      if (this.statusType == "Visit") {
        await this.getVisits(this.changeStatus.subjectId, this.visitIndex);
      } else {
        await this.getVisits(this.changeStatus.subjectId, this.visitIndex);
        await this.getFormsByVisit(
          this.changeStatus.subjectId,
          this.changeStatus.visitNo,
          this.selectedVisitName,
          this.visitIndex
        );
      }
    },
    async getEPROFormsList() {
      const idtoken = store.getters.getIdToken;
      const currentstudy = await store.getters.getStudyIs;
      await axios
        .get(`${this.baseapi}/management/epro/ecrfformslist?studyId=${currentstudy}&category=ePRO`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.data) {
            this.ecrfformlist = response.data.entities;
          } else {
            console.log("No ePRO forms found");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async saveForm(forms) {
      const idtoken = store.getters.getIdToken;
      try {
        if ((forms.useDate && forms.useRecurrence) || (!forms.useDate && !forms.useRecurrence)) {
          alert("Please choose either 'Select Date' or 'Recurrence Cycle'.");
          return;
        }
        if (forms.useDate) {
          if (!forms.selectedDate) {
            alert("Please select a date.");
            return;
          }
        }
        if (forms.useRecurrence) {
          if (!forms.selectedRecurrence) {
            alert("Please select a recurrence cycle.");
            return;
          }
          if (!forms.recurrenceFromDate) {
            alert("Please select a from date.");
            return;
          }
          if (!forms.occurrence || forms.occurrence < 1) {
            alert("Please enter a valid occurrence (min 1).");
            return;
          }
        }
        this.referanceType = "";
        this.occuranceStartDate = "";
        this.totalOccurance = "";
        if (forms.useDate) {
          this.occuranceStartDate = forms.selectedDate;
          this.totalOccurance = 1;
          this.referanceType = "Daily";
        } else if (forms.useRecurrence) {
          this.referanceType = forms.selectedRecurrence;
          this.occuranceStartDate = forms.recurrenceFromDate;
          this.totalOccurance = forms.occurrence;
        }

        this.templateName = forms.templateName;
        this.templateId = forms.template_ID;

        const response = await axios.post(
          `${this.baseapi}/management/patientschedule/eprooccurrenceforms?SubjectId=${this.selectedPatientId}&ReferanceType=${this.referanceType}&OccuranceStartDate=${this.occuranceStartDate}&VisitName=${this.selectedVisitName}&TotalOccurance=${this.totalOccurance}&TemplateName=${this.templateName}&TemplateId=${this.templateId}&visitType=Subject%20Visit`,
          {},
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        alert(this.$t("navigations.epro forms assigned successfully"));
        this.referanceType = "";
        this.occuranceStartDate = "";
        this.totalOccurance = "";
        this.templateName = "";
        this.templateId = "";
        if (forms.useDate) {
          forms.selectedDate = "";
          forms.useDate = false;
        }
        if (forms.useRecurrence) {
          forms.selectedRecurrence = "";
          forms.recurrenceFromDate = "";
          forms.occurrence = "";
          forms.useRecurrence = false;
        }
        console.log("API Response:", response.data);
      } catch (error) {
        console.error("Error calling ePRO occurrence forms API:", error);
      }
    },
    loadPage: function (page) {
      this.currentoverduePage = page;
      this.pageoverdueindex = this.currentoverduePage;
      this.getoverduevisits();
    },
    loadPlanned: function (page) {
      this.currentplannedPage = page;
      this.pageplannedindex = this.currentplannedPage;
      this.getplannedvisits();
    },
    loadForm: function (page) {
      this.currentformPage = page;
      this.pageformindex = this.currentformPage;
      this.getForms();
    },
    loadrecentForm: function (page) {
      this.currentRecentformPage = page;
      this.recentpageformindex = this.currentRecentformPage;
      this.GetRecentFormData();
    },
  },
};
